
function CompaignBody({ campaignbody }) {
    return (
        <div className="space-y-12 mb-12">
            <div className="grid grid-cols-1 gap-8">
                {campaignbody?.map((section, index) => (
                    <CompaignbodyElements key={index} {...section} />
                ))}
            </div>


        </div>
    )
}

export default CompaignBody;

function CompaignbodyElements({ field_title, field_text }) {
    return (
        <section className="bg-card rounded-xl shadow-xl p-8">
            <h2 className="text-2xl font-bold text-foreground mb-6">{field_title}</h2>
            <p className="text-foreground leading-relaxed" 
               dangerouslySetInnerHTML={{ __html: field_text }}>
            </p>
        </section>
    )
}
















